import { styled } from "@mui/material";

export const FILL_VIEWPORT_MAX_HEIGHT = "--FillViewport-max-height";
export const FULL_VIEWPORT = "--FillViewport-full-height";

interface RootProps {
  maxChromeSpacing: string;
  fullHeight?: boolean;
}
export const Root = styled("div")<RootProps>(({
  theme,
  fullHeight,
  maxChromeSpacing,
}) => {
  const SCREEN_BREAK = theme.spacing(theme.layout.SCREEN_BREAK_1);

  // top (40px) and bottom (40px) padding
  const MIN_CHROME_SPACING =
    theme.layout.NAVBAR_HEIGHT + 2 * theme.layout.BODY_MARGIN;

  return {
    [FILL_VIEWPORT_MAX_HEIGHT]: `min(100vh - ${theme.spacing(
      MIN_CHROME_SPACING,
    )}, ${SCREEN_BREAK} - ${maxChromeSpacing})`,

    display: "flex",
    flex: 1,
    flexDirection: "column",
    overflow: "auto",

    maxHeight: `var(${FILL_VIEWPORT_MAX_HEIGHT})`,
    // in general, we just want to hard-code the height, but height alone is insufficient
    minHeight: fullHeight ? `var(${FILL_VIEWPORT_MAX_HEIGHT})` : undefined,
    height: fullHeight ? `var(${FILL_VIEWPORT_MAX_HEIGHT})` : undefined,

    // on larger screens with more vertical space, allow room for the app
    // chrome and no scrolling
    [`@media (min-height: ${SCREEN_BREAK})`]: {
      [FILL_VIEWPORT_MAX_HEIGHT]: `calc(100vh - ${maxChromeSpacing})`,
    },
  };
});
